import React, { useEffect } from "react";
import { useState } from "react";
import ImageUploadPopup from "./ImageUploadPopup/ImageUploadPopup";
import classes from "./UploadPopup.module.css";
import VideoUploadPopup from "./VideoUploadPopup/VideoUploadPopup";

const UploadPopup = ({ popupType, close, addCallback, initValues = {} }) => {

    const typeToUpload = {
        image: ImageUploadPopup,
        video: VideoUploadPopup
    }
    const [typeComponent, setComponent] = useState(null)


    useEffect(() => {
        const TypeComponent = typeToUpload[popupType]
        setComponent(
            <TypeComponent
                initValues={initValues}
                addCallback={addCallback}
                close={close} />)
    }, [popupType])

    return <div className={classes.Backdrop}>
        {typeComponent}
    </div>
}

export default UploadPopup;